import { render, staticRenderFns } from "./security_partners.vue?vue&type=template&id=6b5966e0&"
import script from "./security_partners.vue?vue&type=script&lang=js&"
export * from "./security_partners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports